import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as PaymentIlustration } from "../assets/images/Payment.svg";
import Button from "../components/button/Button";
import Paragraph from "../components/paragraph/Paragraph";
import { ROUTES } from "../constants/routes";
import { useCheckoutSubscription } from "../hooks/useCheckoutSubscription";
import { useCheckoutOneTime } from "../hooks/useCheckoutOneTime";
import { useSubscriptionPrice } from "../hooks/useSubscriptionPrice";
import { useEffect } from "react";
import { SUBSCRIPTION_PLANS, ONE_TIME_PLANS } from "../constants/plans";

// Jedinstven izvor podataka — isti planovi kao na /subscription stranici
const ALL_PLANS = [...SUBSCRIPTION_PLANS, ...ONE_TIME_PLANS];

const ConfirmPlan = () => {
  const { state } = useLocation();
  const {
    mutate: checkoutSubscriptionMutate,
    isLoading: isCheckoutSubscriptionLoading,
  } = useCheckoutSubscription();
  const {
    mutate: checkoutOneTimeMutate,
    isLoading: isCheckoutOneTimeLoading,
  } = useCheckoutOneTime();
  const navigate = useNavigate();

  const subscriptionType = state?.subscriptionType;
  const plan = ALL_PLANS.find(
    (p) => p.subscriptionType === subscriptionType
  );

  // Jednokratni planovi idu na /checkout-for-one-time-access, pretplata na /checkout-for-subscription
  const checkoutSubscription = plan?.isOneTime
    ? checkoutOneTimeMutate
    : checkoutSubscriptionMutate;
  const isCheckoutLoading = plan?.isOneTime
    ? isCheckoutOneTimeLoading
    : isCheckoutSubscriptionLoading;

  const { data: subscriptionPrice } = useSubscriptionPrice(subscriptionType);

  // Bez izabranog (ili nepoznatog) plana nema šta da se potvrdi
  useEffect(() => {
    if (!subscriptionType || !plan) {
      navigate(ROUTES.subscription);
    }
  }, [navigate, subscriptionType, plan]);

  const handleCheckout = () => {
    checkoutSubscription(
      {
        ...(plan?.isOneTime
          ? { oneTimeAccessType: subscriptionType }
          : { subscriptionType }),
        successUrl: `${process.env.REACT_APP_BASE_URL}${ROUTES.checkoutSuccess}?redirectTo=${ROUTES.home}`,
        cancelUrl: window.location.href,
      },
      {
        onSuccess: (variable) => {
          // @ts-ignore
          const { checkoutLink } = variable;

          if (checkoutLink) {
            window.location.href = checkoutLink;
          }
        },
      }
    );
  };

  if (!plan) {
    return null;
  }

  const priceLabel = subscriptionPrice
    ? `${Math.round(subscriptionPrice.amount / 100)}€`
    : "--€";

  const buttonLabel = plan.isOneTime ? "Kupi" : "Započni svoj plan";

  return (
    <div className="confirm-plan">
      <PaymentIlustration className="confirm-plan__image hover-float" />
      <div className="confirm-plan__content">
        <h1 className="confirm-plan__title">Potvrda uplate</h1>
        <div className="confirm-plan__card">
          <div>
            <div className="confirm-plan__card-title">
              <h2>{plan.title}</h2>
              {plan.discount ? (
                <div className="confirm-plan__discount">
                  <Paragraph variant="title">Popust {plan.discount}€</Paragraph>
                </div>
              ) : null}
            </div>
            <Paragraph variant="p1">{plan.subtitle}</Paragraph>
          </div>
          <div>
            <Paragraph variant="p2">{plan.description}</Paragraph>
          </div>
          <h2>{priceLabel}</h2>
        </div>
        <div className="confirm-plan__cta">
          <Button
            variant="white-outlined"
            label="Ostali planovi"
            onClick={() => navigate(ROUTES.subscription)}
          />
          <Button
            variant="primary"
            label={buttonLabel}
            isLoading={isCheckoutLoading}
            onClick={handleCheckout}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmPlan;
